import React, { useState } from "react";

const Marker = ({ lat, lng, text, details }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: "relative",
        cursor: "pointer",
        transform: "translate(-50%, -50%)",
      }}>
      {/* Marqueur principal */}
      <div
        style={{
          backgroundColor: "red",
          color: "white",
          padding: "5px 10px",
          borderRadius: "50%",
          textAlign: "center",
        }}>
        {text}
      </div>

      {/* Carte affichée au survol */}
      {hovered && (
        <div
          style={{
            position: "absolute",
            top: "-100px",
            left: "-50px",
            width: "150px",
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "10px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            zIndex: 10,
          }}>
          <h4 style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            {details.title}
          </h4>
          <p style={{ margin: 0, fontSize: "12px" }}>{details.description}</p>
        </div>
      )}
    </div>
  );
};

export default Marker;
